<template>
  <div class="machine-vision">
    <div class="solution-banner">
      <img src="@/assets/images/website/solution/machine-vision/banner.png" />
    </div>
    <div class="surface-inspection">
      <div class="website-container">
        <h2>光学表面缺陷检测</h2>
        <div class="surface-inspection-item">
          <img alt src="@/assets/images/website/solution/machine-vision/dot.png" />
          <span>缺陷全面实时检测和定位</span>
        </div>
        <div class="surface-inspection-item">
          <img alt src="@/assets/images/website/solution/machine-vision/dot.png" />
          <span>检测数据可以为中间产品、成品分级与销售提供量化依据</span>
        </div>
        <div class="surface-inspection-item">
          <img alt src="@/assets/images/website/solution/machine-vision/dot.png" />
          <span>提高产品在市场上的竞争力</span>
        </div>
        <div class="surface-inspection-item">
          <img alt src="@/assets/images/website/solution/machine-vision/dot.png" />
          <span>提高质量追溯能力，优化质量提升，控制质量索赔损失</span>
        </div>
        <div class="surface-inspection-item">
          <img alt src="@/assets/images/website/solution/machine-vision/dot.png" />
          <span>广泛应用在铝带（箔）拉矫、清洗、分切、分卷等机组及铜带拉矫、酸洗机组</span>
        </div>
        <div>
          <div class="surface-inspection-pic">
            <img class="surface-inspection-pic-left" src="@/assets/images/website/solution/machine-vision/part_1_1.png" />
            <img class="surface-inspection-pic-right" src="@/assets/images/website/solution/machine-vision/part_1_2.png" />
          </div>
          <div>
            <img class="surface-inspection-pic-left" src="@/assets/images/website/solution/machine-vision/part_1_3.png" />
            <img class="surface-inspection-pic-right" src="@/assets/images/website/solution/machine-vision/part_1_4.png" />
          </div>
        </div>
      </div>
    </div>
    <div class="size-scanning">
      <div class="website-container">
        <h2>非接触式产品外形尺寸扫描设备</h2>
        <div class="size-scanning-item">
          <img alt src="@/assets/images/website/solution/machine-vision/dot.png" />
          <span>采用双驱柔性龙门结构设计，电机选用直线+伺服电机构架方式</span>
        </div>
        <div class="size-scanning-item">
          <img alt src="@/assets/images/website/solution/machine-vision/dot.png" />
          <span>此架构方式具有高稳定性、高响应、精度高 、速度快、适合频繁加减速、高定位场合等优点</span>
        </div>
        <div class="size-scanning-item">
          <img alt src="@/assets/images/website/solution/machine-vision/dot.png" />
          <span>系统配合3D相机 、2D相机、激光传感器能够在非接触的情况下测量产品外围轮廓 、孔距、尺寸</span>
        </div>
        <div class="size-scanning-pic">
          <img class="size-scanning-pic-left" src="@/assets/images/website/solution/machine-vision/part_2_1.png" />
          <img class="size-scanning-pic-middle" src="@/assets/images/website/solution/machine-vision/part_2_2.png" />
          <img class="size-scanning-pic-right" src="@/assets/images/website/solution/machine-vision/part_2_3.png" />
        </div>
        <div>
          <img class="size-scanning-pic-left" src="@/assets/images/website/solution/machine-vision/part_2_4.png" />
          <img class="size-scanning-pic-middle" src="@/assets/images/website/solution/machine-vision/part_2_5.png" />
          <img class="size-scanning-pic-right" src="@/assets/images/website/solution/machine-vision/part_2_6.png" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {}
</script>
<style lang="less" scoped>
.solution-banner {
  width: 100%;
  img {
    width: 100%;
    object-fit: cover;
  }
}
.surface-inspection {
  padding: 30px 0;
  h2 {
    line-height: 40px;
    margin: 10px 0 20px 0;
  }
  .surface-inspection-item {
    line-height: 28px;
    margin: 4px 0;
    img {
      padding-right: 6px;
    }
  }
  .surface-inspection-pic {
    margin: 16px 0;
  }
  .surface-inspection-pic-left {
    width: 700px;
    margin-right: 18px;
  }
  .surface-inspection-pic-right {
    width: 560px;
  }
}
.size-scanning {
  background: linear-gradient(#f6f7f9, #ffffff);
  padding: 30px 0;
  h2 {
    line-height: 40px;
    margin: 10px 0 20px 0;
  }
  .size-scanning-item {
    line-height: 28px;
    margin: 4px 0;
    img {
      padding-right: 6px;
    }
  }
  .size-scanning-pic {
    margin: 16px 0;
  }
  .size-scanning-pic-left {
    width: 540px;
    height: 305px;
    margin-right: 10px;
  }
  .size-scanning-pic-middle {
    width: 500px;
    height: 305px;
    margin-right: 10px;
  }
  .size-scanning-pic-right {
    width: 210px;
    height: 305px;
  }
}
</style>
